import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { data } from "../../../assets/data/project";
import { Search } from "../../../assets/ThemeIcon";
import Close from "../../../components/icons/Close";
import ProjectPopup from "./ProjectPopup";
import WorkProcessShape from "./shapes/WorkProcessShape";
const Project = () => {
	const handleSubmit = (e) => {
		e.preventDefault();
	};
	const [index, setIndex] = useState(1);
	const [popupIndex, setPopupIndex] = useState(0);
	const [popup, setPopup] = useState(false);
	const [projectPopup, setProjectPopup] = useState(false);
	const tab__data = data.map((item) => item);
	const { content } = tab__data[index];
	const modal_data = content[popupIndex];

	return (
		<section className="project-section">
			<div className="WorkProcessShape">
				<WorkProcessShape />
			</div>
			<div className="container">
				<div className="section-header">
					<ul className="tab-menu">
						{tab__data &&
							tab__data.map((item, i) => (
								<li
									key={i}
									onClick={() => setIndex(i)}
									className={index === i ? "active" : ""}
								>
									{item.title}
								</li>
							))}
					</ul>
					<form className="search-form" onSubmit={handleSubmit}>
						<div className="__input-group position-relative">
							<input
								type="text"
								className="form-control pl-20"
								placeholder="Search by name, symbol or address"
							/>
							<button type="submit">
								<Search />
							</button>
						</div>
					</form>
				</div>
				<div className="row g-4 g--4 justify-content-center">
					{content &&
						content.map(
							(
								{
									img,
									icon,
									name,
									subname,
									link,
									total_raised,
									starts_on,
								},
								i
							) => (
								<div className="col-xl-4 col-md-6" key={i}>
									<div className="project__item">
										<div className="project__item-img">
											<img src={img} alt="" />
										</div>
										<div className="project__item-content">
											<div className="d-flex justify-content-between">
												<div className="project__item-author">
													<img src={icon} alt="" />
													<div className="info">
														<h5 className="name">{name}</h5>
														<span>{subname}</span>
													</div>
												</div>
												<div className="link">
													<Link to={link}>Project website</Link>
												</div>
											</div>
											<ul>
												<li>
													<span>Total Raised</span>
													<strong>{total_raised}</strong>
												</li>
												<li>
													<span>Starts on</span>
													<strong>{starts_on}</strong>
												</li>
											</ul>
											<div onClick={() => setPopupIndex(i)}>
												<button
													type="button"
													className="btn btn-base w-100"
													onClick={() => setPopup(!popup)}
												>
													Participate
												</button>
											</div>
										</div>
									</div>
								</div>
							)
						)}
				</div>
			</div>
			<ParticipatePopup
				popup={projectPopup}
				setPopup={setProjectPopup}
				modal_data={modal_data}
			/>
			<ProjectPopup
				popup={popup}
				setPopup={setPopup}
				modal_data={modal_data}
				secondPopup={projectPopup}
				setSecondPopup={setProjectPopup}
			/>
		</section>
	);
};

export const ParticipatePopup = ({
	popup,
	setPopup,
	modal_data,
	buttonTitle,
}) => {
	const { icon, name } = modal_data;
	return (
		<Modal
			show={popup}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Body>
				<div className="modal-close" onClick={() => setPopup(!popup)}>
					<Close />
				</div>
				<div className="__participate-popup-content">
					<img src={icon} alt="" />
					<h4 className="subtitle">{name}</h4>
					<h4 className="sale">Sale</h4>
					<div className="text">Spendable Algo Balance: 0.01 ALGO</div>
					<form>
						<div className="__input-group">
							<input
								type="text"
								className="form-control"
								placeholder="0.00"
							/>
							<span className="max">Max</span>
						</div>
						<button type="submit" className="btn btn-base w-100">
							Participate
						</button>
					</form>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default Project;
